<template>
    <jb-buttons no-wrap>
        <jb-button color="warning" class="buttons" :icon="mdiMagnify" small @click="showDetail" />
        <jb-button color="success" class="buttons" :icon="mdiCircleEditOutline" small @click="editClass" v-if="checkUser && (!this.params.data.state || this.params.data.state == 'Draft')" />
        <jb-button color="danger" class="buttons" :icon="mdiTrashCan" small @click="deleteAction" v-if="checkUser && (!this.params.data.state || this.params.data.state == 'Draft')" />
        <jb-button v-if="'is_compulsory' in this.params.data" color="info" :icon="mdiAccount" small @click="addTeacher" />
        <jb-button v-if="'teacher_role_id' in this.params.data" color="info" :icon="mdiAccount" small @click="jobdesk" />
        <jb-button v-if="'is_graduate' in this.params.data" color="info" :icon="mdiAccount" small @click="graduatePromotion" />
    </jb-buttons>
</template>
<script>
    import JbButtons from '@/components/JbButtons'
    import JbButton from '@/components/JbButton'
    import { onMounted, ref } from '@vue/runtime-core'
    import {
        mdiCircleEditOutline,
        mdiTrashCan,
        mdiMagnify,
        mdiAccount
    } from '@mdi/js'
    import CryptoJS from 'crypto-js'

    export default {
        name: 'ButtonMaster',
        components: {
            JbButtons,
            JbButton
        },
        setup (props) {
            const userRole = localStorage.getItem('roles')
            const checkUser = ref(false)
            const userCheck = async () => {
                if (userRole !== null) {
                    const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
                    const myArray = decryptedMessage.split(',')
                    for (let i = 0; i < myArray.length; i++) {
                        if (myArray[i] === 'ROLE_ADMIN' || myArray[i] === 'ROLE_ADMIN_HRD' || myArray[i] === 'ROLE_ADMIN_FINANCE' || myArray[i] === 'ROLE_TEACHER' || myArray[i] === 'ROLE_BOOKING' || myArray[i] === 'ROLE_FINANCE') {
                            checkUser.value = true
                        }
                    }
                }
                // console.log('checkUser:', checkUser.value)
            }
            onMounted(() => {
                userCheck()
            })
            return {
                userRole,
                userCheck,
                checkUser,
                mdiCircleEditOutline,
                mdiTrashCan,
                mdiAccount,
                mdiMagnify
            }
        },
        methods: {
            showDetail (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.detailData(event, this.params.data, this.params.data.id)
            },
            editClass (event) {
                // the grid component can now be accessed via this.params.context.componentParent
                this.params.context.componentParent.editData(event, this.params.data)
            },
            deleteAction () {
                this.params.context.componentParent.deleteModalShow(this.params.value)
            },

            addTeacher () {
                this.$router.push('/teacherextracuricular')
            },
            jobdesk (event) {
                this.params.context.componentParent.teacherJobdesk(event, this.params.data)
            },
            graduatePromotion () {
                this.$router.push('/promotion')
            }
        }
    }
</script>
